/// <reference path="~/Scripts/_references.js"/>
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/PriceTableModelV2.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/OrderOptionsModelV2.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/AdditionalWorkModelV2.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ConfigurationSummaryModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/SubmitModelV2.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/OfferModelV2.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/SammyModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductContentModeModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/TopProductModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/FilePresetModel.js" />

var PageModel = function (objectId) {
    var that = this;

    that.IsCatalogueProduct = ko.observable(false);
    that.CatalogueProductDisplayText = ko.observable("");

    //baseData
    that.ObjectId = ko.observable(objectId);
    that.EditId = ko.observable("-1"); //"-1" == new Product()
    that.CurrencySymbol = ko.observable(userSettings.currentCurrencySymbol);
    that.TeaserPanel = ko.observable("");
    that.AdditionalTeaserPanel = ko.observable("");
    that.CurrentHash = ko.observable("");
    that.EditCoupon = ko.observable();
    that.ProductConfigurationV3Enabled = ko.observable();

    //subData
    that.InjectValue = ko.observable(0);
    that.DiffWithPickup = ko.observable(0);
    that.CurrentAmount = ko.observable(0);
    that.CurrentMachine = ko.observable();
    that.CurrentNetPrice = ko.observable(0);
    that.AdvantageousAmount = ko.observable(-1);
    that.PriceDiff = ko.observable(0);
    that.ShowData = ko.observableArray([]);
    that.EditData = ko.observableArray([]);
    that.EditOrderData = ko.observableArray([]);
    that.EditOrderPositionId = ko.observable();
    that.DesignerUserItemId = ko.observable();
    that.DesignName = ko.observable();
    that.OrderPositionId = ko.observable();
    that.DefaultDeliveryCountryId = ko.observable();
    that.IsScrollingRequired = ko.observable(false);

    //storage
    that.ItemCount = ko.observableArray([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]); //TODO: dynamic
    that.SelectedItemCount = ko.observable();
    that.SubmitText = ko.observable(SubmitTextShoppingCart);

    // Attribute with the given ID will be replaced by a ImageGallery. Basically a different display mode.
    that.ImageSliderAttributeId = ko.observable();
    // All Attribute with the IDs entered below will not be displayed. Usefull if there is only one option to select.
    that.HiddenAttributeIds = ko.observableArray([]);

    //childViewModels
    that.pProductContentModeModel = ko.observable();
    that.pProductModel = ko.observable();
    that.pCalculationModel = ko.observable();
    that.pSammyModel = ko.observable();
    that.pSummaryModel = ko.observable();

    //flags
    that.IsInitialScrollDownDone = ko.observable(false);
    that.IsTopProductModelPopulated = ko.observable(false);
    that.IsProductModelPopulated = ko.observable(false);
    that.IsPriceTableModelPopulated = ko.observable(false);
    that.IsOrderOptionsModelPopulated = ko.observable(false);
    that.IsOrderCreationProgressLoading = ko.observable(false);
    that.IsInitialLoadDone = ko.observable(false);
    that.IsEditDataAvailable = ko.observable(false);
    that.IsShowDataAvailable = ko.observable(false);
    that.IsEditOrderDataAvailable = ko.observable(false);
    that.IsEditMode = ko.observable(false);
    that.IsAdvantageousAmountAvailable = ko.observable(false);
    that.IsBeginnerModeReady = ko.observable(false);
    that.IsInitialAmount = ko.observable(true);
    that.IsAdGalleryInitialized = ko.observable(false);
    that.IsOrderOptionModeDisabled = ko.observable(false);
    that.IsPriceTableCollapsedDefault = ko.observable(false);

    //output
    that.StaticAttributes = ko.observableArray([]); // {201: 10501}
    that.StaticOrderOptions = ko.observableArray([]); // {CheckOption: 15}

    that.DisplayCurrentAmount = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.CurrentAmount()) + " " + ProductPieces;
    }, that);

    that.IsCurrentDigitalPrint = ko.computed(function () {
        return that.CurrentMachine() === "NexpressSX3300" ||
            that.CurrentMachine() === "Keilrahmen" ||
            that.CurrentMachine() === "Posterjet";
    }, this);

    that.InitialisizePageModel = function (model) {
        that.pTopProductModel = new TopProductModel(that);
        that.pProductContentModeModel = new ProductContentModeModel(that);
        that.pProductContentModeModel.SetAvailableModes();
        that.pProductModel = new ProductModel(that);
        that.pPriceTableModelV2 = new PriceTableModelV2(that);
        that.pOrderOptionsModelV2 = new OrderOptionsModelV2(that);
        that.pAdditionalWorkModelV2 = new AdditionalWorkModelV2(that);
        that.pOfferModelV2 = new OfferModelV2(that);
        that.pSummaryModel = new ConfigurationSummaryModel(that);
        that.pSammyModel = new SammyModel(that, model);
        that.pFilePresetModel = new FilePresetModel(that);
    };

    that.IsProductModelPopulated.subscribe(function (boolStatus) {
        if (!boolStatus) {
            return;
        }

        if (that.IsShowDataAvailable()) {
            that.CurrentAmount((that.ShowData()).Model.Amount);
            that.pProductModel.RePopulateProductModel((that.ShowData()).Model.SelectedValues);
            return;
        }

        if (that.IsEditDataAvailable()) {
            that.CurrentAmount((that.EditData()).Amount);
            that.pProductModel.RePopulateProductModel((that.EditData()).ProductConfig, true, (that.EditData()).Extensions);
            return;
        }

        if (that.IsEditOrderDataAvailable()) {
            that.CurrentAmount((that.EditOrderData()).Amount);
            that.pProductModel.RePopulateProductModel((that.EditOrderData()).SelectedIds, false, (that.EditOrderData()).Extensions);
            return;
        }
    });

    that.CurrentAmount.subscribe(function (c) {
        if (that.IsInitialLoadDone()) {
            var productionAmountModel = $(that.pPriceTableModel.ProductionAmounts()).filter(function (index) {
                return this.Amount() == c;
            }).get(0);

            if (productionAmountModel != undefined) {
                that.CurrentMachine(productionAmountModel.Machine());
            } else {
                that.CurrentMachine("");
            }
        }
    });

    //functions
    that.SetFavLink = function () {
        //stop *.Sammy.js
        that.pSammyModel.IsPaused(true);

        //set url
        window.location.hash = "/show/" + that.pProductModel.ArticleReference();

        //restart *.Sammy.js
        setTimeout(function () {
            that.pSammyModel.IsPaused(false);
        }, 1000);
    };

    that.getTopProductTitleText = function (topProductName, topProductId) {
        var resourceText = $('#' + topProductId + ' > div.card-body').text();
        return topProductName + ": " + resourceText;
    };

    that.ApplyStaticAttributes = function () {
        console.log("ApplyStaticAttributes", that.StaticAttributes());

        if (!that.StaticAttributes()) {
            return;
        }

        $.each(that.StaticAttributes(), function (key, val) {
            $.each(that.pProductModel.Attributes(), function (attrKey, attribute) {
                if (attribute.AttributeId() == key) {
                    attribute.SelectedObjectValueId(val);
                    attribute.IsValueStatic(true);
                    console.log('StaticAttributeSelected', attribute.LocalizationKey(), attribute.SelectedObjectValueId());
                }
            });
        });
    };
};
